import { useFleet } from '../state/store'

/**
 * Surfaces a 403 as a dismissible banner (Banners.tsx, mounted once in AppShell.tsx)
 * instead of letting it fall through silently to whichever component's local catch
 * happened to call the fetch that failed. Every *Fetch wrapper's 403 branch calls this
 * before throwing -- throwing is unchanged, so existing component-level error states
 * still work exactly as before; this only adds the one thing none of them had: visible
 * feedback that the failure was a permission denial, not a network/server fault.
 *
 * id is derived from the message, not a counter: EimShell/StarShell/BusOpsShell poll
 * every 8-10s, so a department permanently lacking a grant would otherwise re-add a
 * fresh, uniquely-id'd banner every single poll tick forever -- addBanner's own dedup
 * (store.ts) only collapses repeats that share an id. The same denial reappearing after
 * the user dismisses it (next poll tick re-adds it) is the same tradeoff every other
 * addBanner caller here already accepts for a persistent condition.
 *
 * Called from plain async functions, not React components, so this reads the store
 * imperatively (useFleet.getState()) the same way MapCanvas.tsx/BusRouteMap.tsx already
 * do for their own addBanner calls, rather than needing a hook.
 */
export function notifyForbidden(message: string): void {
  useFleet.getState().addBanner({ id: `forbidden-${message}`, tone: 'error', message })
}
